/*
 * transfer 穿梭框
 * author zhousheng
 */
import * as React from 'react';
import classnames from 'classnames';
import OutlinedRight from 'acud-icon/lib/icons/OutlinedRight';
import OutlinedDown from 'acud-icon/lib/icons/OutlinedDown';
import List from '../virtual-list';
import Checkbox from '../checkbox';
import { getBodyHeight, ITEM_HEIGHT } from './util';
const SourceList = (props) => {
    const { filterSource, prefixCls, render, tKeys: targetKeys, setTKeys: setTargetKeys, defaultExpandGroupKey = false, showSearch, leftStyle = {}, virtual = true, onSourceExpandChange } = props;
    const listHeight = React.useMemo(() => {
        return getBodyHeight(leftStyle, showSearch === true || showSearch === 'left');
    }, [leftStyle, showSearch]);
    const itemToggle = React.useCallback(data => {
        if (data.disabled) {
            return;
        }
        let newTargetKeys = [...targetKeys];
        if (data.group) {
            // const groupKeys = data.childrenKeys;
            const undisabledKeys = data.children.filter(child => !child.disabled).map(child => child.key);
            const checkedKeys = undisabledKeys.filter(key => targetKeys.includes(key));
            if (undisabledKeys.length === checkedKeys.length) {
                newTargetKeys = newTargetKeys.filter(tKey => !undisabledKeys.includes(tKey));
            }
            else {
                newTargetKeys = [...new Set([...newTargetKeys, ...undisabledKeys])];
            }
        }
        else if (targetKeys.includes(data.key)) {
            newTargetKeys.splice(targetKeys.indexOf(data.key), 1);
        }
        else {
            newTargetKeys.push(data.key);
        }
        setTargetKeys(newTargetKeys);
    }, [targetKeys]);
    const groupKeys = filterSource.filter(source => source.group).map(source => source.key);
    let expandGroupKeys = [];
    if (defaultExpandGroupKey === true) {
        // 默认展开所有折叠项
        expandGroupKeys = groupKeys;
    }
    else if (Array.isArray(defaultExpandGroupKey)) {
        expandGroupKeys = defaultExpandGroupKey;
    }
    else if (typeof defaultExpandGroupKey === 'string' || typeof defaultExpandGroupKey === 'number') {
        expandGroupKeys = [defaultExpandGroupKey];
    }
    const [expandGroupKey, setExpandGroupKey] = React.useState(expandGroupKeys);
    const expandGroup = React.useCallback((e, groupKey) => {
        let isOpen = false;
        if (expandGroupKey.includes(groupKey)) {
            setExpandGroupKey(keys => {
                keys.splice(keys.indexOf(groupKey), 1);
                return [...keys];
            });
            isOpen = false;
        }
        else {
            setExpandGroupKey(keys => {
                keys.push(groupKey);
                return [...keys];
            });
            isOpen = true;
        }
        onSourceExpandChange && onSourceExpandChange(groupKey, isOpen);
        e.stopPropagation();
    }, [expandGroupKey]);
    const getSourceItem = React.useCallback(data => {
        let checked = targetKeys.includes(data.key);
        let indeterminate = false;
        if (data.group) {
            const undisabledKeys = data.children.filter(child => !child.disabled).map(child => child.key);
            const checkedKeys = undisabledKeys.filter(key => targetKeys.includes(key));
            if (undisabledKeys.length === checkedKeys.length) {
                checked = true;
                indeterminate = false;
            }
            else if (checkedKeys.length) {
                indeterminate = true;
                checked = false;
            }
            else {
                checked = false;
                indeterminate = false;
            }
        }
        const itemCls = classnames({
            [`${prefixCls}-datasource-item`]: true,
            [`${prefixCls}-datasource-item-disabeld`]: data.disabled,
            [`${prefixCls}-datasource-item-group`]: data.group,
            [`${prefixCls}-datasource-item-group-option`]: data.groupOption
        });
        return (<div key={data.key} aria-disabled={data.disabled} className={itemCls} onClick={() => itemToggle(data)} style={{
                display: data.groupOption && !expandGroupKey.includes(data.groupKey)
                    ? 'none'
                    : ''
            }}>
                {data.group && (<span className={`${prefixCls}-datasource-item-arrow`} onClick={e => expandGroup(e, data.key)}>
                        {expandGroupKey.includes(data.key)
                    ? <OutlinedDown />
                    : <OutlinedRight />}
                    </span>)}
                <Checkbox className={`${prefixCls}-datasource-item-checkbox`} checked={checked} disabled={data.disabled} indeterminate={indeterminate}/>
                {render
                ? render(data)
                : (<span className={`${prefixCls}-datasource-item-title`} title={data.title}>{data.title}</span>)}
            </div>);
    }, [
        targetKeys,
        expandGroupKey,
        render
    ]);
    const virtualData = React.useMemo(() => filterSource.filter(data => !(data.groupOption && !expandGroupKey.includes(data.groupKey))), [filterSource, expandGroupKey]);
    return (<div className={`${prefixCls}-datasource-list`}>
        {virtual && <List itemKey="key" data={virtualData} height={listHeight} fullHeight={false} itemHeight={ITEM_HEIGHT}>
            {data => getSourceItem(data)}
        </List>}
        {!virtual && filterSource.map(data => getSourceItem(data))}
    </div>);
};
export default SourceList;
